<div class="flex flex-column field col-12 p-0 m-0">
    @if (label) {
        <label for="item">{{label}}</label>
    }
    <ng-content id="item"></ng-content>
    <div class="field-container-error">
        {{ getError() || errorMessage }}
    </div>
</div>
